import type { FetchTeams } from "@vTypes/roster.types";

/**
 * 주어진 간호사 ID가 속한 팀의 이름을 찾습니다.
 * @param nurseId - 찾고자 하는 간호사의 ID
 * @param teamsSchema - 전체 팀 목록
 * @returns 팀 이름. 소속된 팀이 없으면 빈 문자열을 반환합니다.
 */
export const findNurseTeamName = (
    nurseId: string | undefined,
    teamsSchema: FetchTeams[]
): string => {
    if (!nurseId || !teamsSchema || !teamsSchema.length) return "";
    const team = teamsSchema.find((t) => t.team_members.includes(nurseId));
    return team ? team.team_name : "";
};
